<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as CONTACT_ROLE_TYPES } from './store'
import { ROUTES as CONTACT_ROLE_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../../components/thux-list/ThuxListMixin'

import ContactRoleTable from './ContactRoleTable'
import ContactRoleCommonFilters from './ContactRoleCommonFilters'
import ContactRoleEdit from './ContactRoleEdit.vue'

export default {
  name: 'ContactRoleList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': ContactRoleTable,
    'common-filters': ContactRoleCommonFilters,
    'component-detail': ContactRoleEdit,
    'component-edit': ContactRoleEdit
  },
  data () {
    return {
      CONTACT_ROLE_ROUTES,
      title: this.$t('Contact roles'),
      rolePerm: ['organization_contactrole_list'],
      actionEnablePermission: ['organization_contactrole_enable'],
      actionDisablePermission: ['organization_contactrole_disable'],
      searchFields: [
        { key: 'filter__code__icontains', placeholder: this.$t('Code'), type: 'text', col: 6 },
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 6 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...CONTACT_ROLE_TYPES.GENERIC.organization.contactrole.LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.CONTACT_ROLE_ROUTES.CONTACT_ROLE_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('organization_contactrole_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: CONTACT_ROLE_TYPES.GENERIC.organization.contactrole.LIST.MUTATIONS.setSelectedList,
      setSelectAll: CONTACT_ROLE_TYPES.GENERIC.organization.contactrole.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...CONTACT_ROLE_TYPES.GENERIC.organization.contactrole.LIST.ACTIONS
    })
  }
}
</script>
